import { createRoute } from "../../utils";

import { laboratoryBreadcrumbs, laboratoryRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { IRole } from "@/interfaces";

const permission = [IRole.FACULTY_MEMBER];

const laboratoriesRouteMetadata: IRouteMetadataObj<typeof laboratoryRoutesObj> =
  {
    list: {
      title: "laboratoriesManagement",
      lazy: () => import("@/pages/facultyMemberPanel/laboratory/table/page"),
      mode: "index",
      permission,
    },
    create: {
      title: "addNewLaboratory",
      lazy: () => import("@/pages/facultyMemberPanel/laboratory/form/page"),
      mode: "create",
      permission,
    },
    edit: {
      title: "editLaboratoryOf",
      lazy: () => import("@/pages/facultyMemberPanel/laboratory/form/page"),
      mode: "edit",
      permission,
    },
    view: {
      title: "viewLaboratoryOf",
      lazy: () => import("@/pages/facultyMemberPanel/laboratory/form/page"),
      mode: "view",
      permission,
    },
  };

export const laboratoriesRoutes = createRoute<typeof laboratoryRoutesObj>(
  laboratoryRoutesObj,
  laboratoriesRouteMetadata,
  laboratoryBreadcrumbs,
);
